module.exports = __webpack_public_path__ + "static/media/PrinterSmall.27af488a.svg";